package er.prateek.crossly.progression

import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.setValue
import er.prateek.crossly.data.model.SavedPuzzleSession
import er.prateek.crossly.persistence.SavedSessionStore

class SavedSessionManager(
    private val store: SavedSessionStore,
) {
    var session: SavedPuzzleSession? by mutableStateOf(loadResumable())
        private set

    /** Older builds saved untouched puzzles too, offering "Resume" on an empty grid; drop those. */
    private fun loadResumable(): SavedPuzzleSession? {
        val saved = store.load() ?: return null
        if (saved.hasPlayerInput) return saved
        store.save(null)
        return null
    }

    fun save(session: SavedPuzzleSession) {
        this.session = session
        store.save(session)
    }

    fun clear() {
        session = null
        store.save(null)
    }

    fun clearIfPuzzle(puzzleId: String) {
        if (session?.puzzleId == puzzleId) clear()
    }

    fun sessionFor(puzzleId: String): SavedPuzzleSession? =
        session?.takeIf { it.puzzleId == puzzleId }

    fun dropStaleDaily(todayIso: String) {
        val current = session ?: return
        if (current.isDaily && current.dailyDateIso.isNotEmpty() && current.dailyDateIso != todayIso) {
            clear()
        }
    }
}
